import styled, { css } from 'styled-components'

import { fromMd, timingDefault, timingSlower } from '@syconium/little-miss-figgy'

import * as SubComponents from './SubComponents'

export const Menu = styled(SubComponents.Menu)`
  &:first-of-type {
    margin-top: 12px;
  }

  ${fromMd} {
    &:first-of-type {
      margin-top: initial;
    }
  }
`

const MenuLink = styled.span`
  color: ${o => o.theme.color.deprecated.black.secondary};
  position: relative;

  ${fromMd} {
    color: black;

    &:hover {
      font-weight: bold;
    }

    &::after {
      border-bottom: 1px solid black;
      content: '';
      left: 0;
      position: absolute;
      top: 18px;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform ${timingDefault} ease-in;
      width: 100%;
    }

    &:hover::after {
      transform: scaleX(1);
    }
  }
`

export const MenuItemLink = styled(MenuLink)<{
  $emphasize?: boolean
}>`
  font-size: 13px;
  font-weight: ${o => o.$emphasize && 'bold'};
  letter-spacing: 0.5px;
  line-height: 30px;

  ${fromMd} {
    font-size: 11px;
    line-height: 2.272727em;
    letter-spacing: 0.8px;
  }
`

export const fadableSegment = css<{ $isFadedOut?: boolean }>`
  opacity: ${o => o.$isFadedOut && '0.2'};
  pointer-events: ${o => o.$isFadedOut && 'none'};
  transition: opacity ${timingSlower} ease;
`
